// extracted by mini-css-extract-plugin
module.exports = {"label":"ManageProjectsTreePage_label__3Irp4"};